import { MenuItem } from '@card-software/library';
import {
  AccountsPayableRoles,
  BankAccountRoles,
  BankTransactionRoles,
  BusinessRoles,
  CostingRoles,
  ExchangeRateRoles,
  MonthlyUploadsRoles,
  CostCenterRoles,
  ExpenseConceptRoles,
  GlAccountRuleRoles,
  PettyCashRoles,
} from './models/roles/roles-group';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Businesses',
    routerLink: '/businesses',
    redirect: true,
    roles: [BusinessRoles.BusinessViewer, BusinessRoles.BusinessAdmin],
  },
  {
    displayName: 'Exchange Rate',
    routerLink: '/exchange-rate',
    redirect: true,
    roles: [ExchangeRateRoles.ExchangeRateViewer, ExchangeRateRoles.ExchangeRateAdmin],
  },
  {
    displayName: 'Cost Analysis',
    routerLink: '/cost-analysis',
    redirect: true,
  },
  {
    displayName: 'Pools',
    routerLink: '/costs/pools',
    redirect: true,
    roles: [CostingRoles.FinanceCalculatorAdmin],
  },
  {
    displayName: 'Reports',
    routerLink: '/costs/reports',
    redirect: true,
    roles: [CostingRoles.FinanceCostingAdmin],
  },
  {
    displayName: 'Bank Accounts',
    routerLink: '/bank-accounts',
    redirect: true,
    roles: [BankAccountRoles.BankAccountViewer, BankAccountRoles.BankAccountAdmin],
  },
  {
    displayName: 'Bank Transactions',
    routerLink: '/bank-transactions',
    redirect: true,
    roles: [BankTransactionRoles.BankTransactionViewer, BankTransactionRoles.BankTransactionAdmin],
  },
  {
    displayName: 'Internal Transfers',
    routerLink: '/internal-transfers',
    redirect: true,
    roles: [BankTransactionRoles.BankTransactionViewer, BankTransactionRoles.BankTransactionAdmin],
  },
  {
    displayName: 'Bank Statements',
    routerLink: '/bank-statements',
    redirect: true,
    roles: [BankAccountRoles.BankAccountViewer, BankAccountRoles.BankAccountAdmin],
  },
  {
    displayName: 'Bank Reconciliation',
    routerLink: '/bank-reconciliation',
    redirect: true,
    roles: [BankTransactionRoles.BankTransactionViewer, BankTransactionRoles.BankTransactionAdmin],
  },
  {
    displayName: 'AP Documents',
    routerLink: '/ap-documents',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'AP Payments',
    routerLink: '/ap-payments',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'AP Payment Requests',
    routerLink: '/ap-payment-requests',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin, AccountsPayableRoles.AccountsPayableApprover],
  },
  {
    displayName: 'AP Aging',
    routerLink: '/ap-aging',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Monthly Uploads',
    routerLink: '/monthly-uploads',
    redirect: true,
    roles: [MonthlyUploadsRoles.MonthlyUploadsViewer, MonthlyUploadsRoles.MonthlyUploadsAdmin],
  },
  {
    displayName: 'Tax Authorizations',
    routerLink: '/tax-authorizations',
    redirect: true,
    roles: [BusinessRoles.BusinessViewer, BusinessRoles.BusinessAdmin],
  },
  {
    displayName: 'Petty cash funds',
    routerLink: '/petty-cash-funds',
    redirect: true,
    roles: [PettyCashRoles.PettyCashFundViewer, PettyCashRoles.PettyCashFundAdmin, PettyCashRoles.PettyCashTreasurer],
  },
  {
    displayName: 'Trips',
    routerLink: '/trips',
    redirect: true,
    roles: [PettyCashRoles.TripViewer, PettyCashRoles.TripAdmin, PettyCashRoles.TripApprover],
  },
  {
    displayName: 'Capture receipts',
    routerLink: '/expense-receipts',
    redirect: true,
    roles: [
      PettyCashRoles.PettyCashFundViewer,
      PettyCashRoles.PettyCashFundAdmin,
      PettyCashRoles.TripViewer,
      PettyCashRoles.TripAdmin,
      PettyCashRoles.TripApprover,
      PettyCashRoles.ExpenseClaimViewer,
      PettyCashRoles.ExpenseClaimAdmin,
    ],
  },
  {
    displayName: 'Expense claims',
    routerLink: '/expense-claims',
    redirect: true,
    roles: [
      PettyCashRoles.PettyCashFundViewer,
      PettyCashRoles.PettyCashFundAdmin,
      PettyCashRoles.TripViewer,
      PettyCashRoles.TripAdmin,
      PettyCashRoles.TripApprover,
      PettyCashRoles.ExpenseClaimViewer,
      PettyCashRoles.ExpenseClaimAdmin,
      PettyCashRoles.ClaimApprover,
      PettyCashRoles.ClaimAccountingReviewer,
    ],
  },
  {
    displayName: 'Employee advances',
    routerLink: '/employee-advances',
    redirect: true,
    roles: [PettyCashRoles.PettyCashTreasurer, PettyCashRoles.TripViewer, PettyCashRoles.TripAdmin],
  },
  {
    displayName: 'Expense settlements',
    routerLink: '/expense-settlements',
    redirect: true,
    roles: [
      PettyCashRoles.PettyCashTreasurer,
      PettyCashRoles.PettyCashFundViewer,
      PettyCashRoles.PettyCashFundAdmin,
      PettyCashRoles.TripViewer,
      PettyCashRoles.TripAdmin,
      PettyCashRoles.ExpenseClaimViewer,
      PettyCashRoles.ExpenseClaimAdmin,
    ],
  },
  {
    displayName: 'Employees',
    routerLink: '/employees',
    redirect: true,
    roles: [BusinessRoles.BusinessViewer, BusinessRoles.BusinessAdmin],
  },
  {
    displayName: 'Journal Entries',
    routerLink: '/journal-entries',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Chart of Accounts',
    routerLink: '/chart-of-accounts',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Accounting Periods',
    routerLink: '/accounting-periods',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Cost Centers',
    routerLink: '/cost-centers',
    redirect: true,
    roles: [CostCenterRoles.CostCenterViewer],
  },
  {
    displayName: 'Expense Concepts',
    routerLink: '/expense-concepts',
    redirect: true,
    roles: [ExpenseConceptRoles.ExpenseConceptViewer, ExpenseConceptRoles.ExpenseConceptAdmin],
  },
  {
    displayName: 'GL Account Rules',
    routerLink: '/gl-account-rules',
    redirect: true,
    roles: [GlAccountRuleRoles.GlAccountRuleViewer, GlAccountRuleRoles.GlAccountRuleAdmin],
  },
  {
    displayName: 'Withholding Taxes',
    routerLink: '/withholding-taxes',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Withholding Certificates',
    routerLink: '/ap-withholdings',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Withholding Remittance',
    routerLink: '/withholding-remittance',
    redirect: true,
    roles: [AccountsPayableRoles.AccountsPayableAdmin],
  },
  {
    displayName: 'Info',
    routerLink: '/info',
    redirect: true,
    roles: [],
  },
];
